import React, { FC, HTMLAttributes, useState, useCallback } from 'react'
import classNames from 'classnames'
import { Else, If, Then } from 'react-if'
import { CaretDownIcon } from '@/atoms/Icons/CaretDownIcon'
import { MinusIcon } from '@/atoms/Icons/MinusIcon'
import { PlusIcon } from '@/atoms/Icons/PlusIcon'
import { CaptionLG } from '@/atoms/Text'
import { IconColor } from '@/atoms/utils'

interface AccordionTriggerProps extends HTMLAttributes<HTMLElement> {
  label?: string | React.ReactNode
  iconColor?: IconColor
  labelClassName?: string
  iconClassName?: string
  shouldUseCaretIcon?: boolean
  shouldDefaultOpen?: boolean
}

export const AccordionTrigger: FC<AccordionTriggerProps> = ({
  className,
  label,
  labelClassName,
  iconColor,
  shouldUseCaretIcon = false,
  shouldDefaultOpen,
  iconClassName,
}) => {
  const [open, setOpen] = useState(shouldDefaultOpen)

  const handleClick = useCallback(() => {
    setOpen(!open)
  }, [open])

  const isTextOnly = typeof label === 'string'

  return (
    <div onClick={handleClick} className={classNames('flex items-center justify-between py-4 text-left', className)}>
      <If condition={isTextOnly}>
        <Then>
          <CaptionLG weight="bold" className={classNames('w-full', labelClassName)}>
            {label}
          </CaptionLG>
        </Then>
        <Else>{label}</Else>
      </If>
      {shouldUseCaretIcon ? (
        <span className="flex h-6 w-6 shrink-0 items-center justify-center">
          <CaretDownIcon
            className={classNames('transition-transform duration-300', open ? 'rotate-180' : 'rotate-0', iconClassName)}
            color={iconColor}
          />
        </span>
      ) : (
        <If condition={open}>
          <Then>
            <MinusIcon className={iconClassName} color={iconColor} />
          </Then>
          <Else>
            <PlusIcon className={iconClassName} color={iconColor} />
          </Else>
        </If>
      )}
    </div>
  )
}
